import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'Store/selectors'
import BottomSheet from 'Components/BottomSheet'
import TextInput from 'Components/Form/Input/TextInput'
import numberFilterOnKeyPress from 'Utils/numberFilterOnKeyPress'
import userManager from 'Oidc/userManager'
import { commonApi, useSetSsoDataMutation } from 'Services/api'
import { COMMON_CACHE_STORE, COMMON_DB_STORE } from 'Services/api/common/common.config'
import { clearAllCache } from 'DataBase/rtk-persist/cache'

interface IProps {
  showUserUpdate: boolean
  setShowUserUpdate: (show: boolean) => void
}

const UserUpdate: React.FC<IProps> = props => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const [setSsoData] = useSetSsoDataMutation()

  const {
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm()

  const IsNationalCode = (identityCode: string): boolean => {
    if (identityCode) {
      if (identityCode.length < 10 || identityCode.length > 10) return false

      var allDigitEqual = [
        '0000000000',
        '1111111111',
        '2222222222',
        '3333333333',
        '4444444444',
        '5555555555',
        '6666666666',
        '7777777777',
        '8888888888',
        '9999999999',
      ]
      if (allDigitEqual.includes(identityCode)) return false

      var num0 = Number(identityCode.substring(0, 1)) * 10
      var num2 = Number(identityCode.substring(1, 2)) * 9
      var num3 = Number(identityCode.substring(2, 3)) * 8
      var num4 = Number(identityCode.substring(3, 4)) * 7
      var num5 = Number(identityCode.substring(4, 5)) * 6
      var num6 = Number(identityCode.substring(5, 6)) * 5
      var num7 = Number(identityCode.substring(6, 7)) * 4
      var num8 = Number(identityCode.substring(7, 8)) * 3
      var num9 = Number(identityCode.substring(8, 9)) * 2
      var a = Number(identityCode.substring(9, 10))

      var b = num0 + num2 + num3 + num4 + num5 + num6 + num7 + num8 + num9
      var c = b % 11

      var result = (c < 2 && a == c) || (c >= 2 && 11 - c == a)
      if (result) return true
      return false
    } else return false
  }

  const submitForm = async (data: any) => {
    userManager.getUser().then(async user => {
      if (user) {
        await setSsoData({
          nationalCode: data.identityCode as string,
          ssoId: String(user.profile.id),
          phoneNumber: user.profile.phone_number || '',
          userName: user.profile.preferred_username || '',
          sub: user.profile.sub,
        }).unwrap()

        await deleteUserData()
        props.setShowUserUpdate(false)
        window.location.reload()
      }
    })
  }

  const deleteUserData = async () => {
    dispatch(commonApi.util.invalidateTags(['UserProfile', 'ExpertFields']))
    await clearAllCache(COMMON_DB_STORE, COMMON_CACHE_STORE)
  }

  return (
    <BottomSheet
      visible={props.showUserUpdate}
      title={t('UPDATE_USER')}
      onCancel={() => props.setShowUserUpdate(false)}
      dontClose={true}
    >
      <div
        style={{
          width: 50,
          height: 6,
          backgroundColor: '#ccc',
          borderRadius: 3,
          position: 'absolute',
          top: 8,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      />
      <div className="overflow-auto px-6 pb-6">
        <div className="text-black text-sm mb-4">{t('UPDATE_USER_MESSAGE')}</div>
        <form>
          <div className="space-y-4" style={{ paddingTop: '5px' }}>
            <TextInput
              inputMode="numeric"
              id="identityCode"
              name="identityCode"
              label={t('NATIONAL_CODE')}
              dir="ltr"
              onKeyPress={numberFilterOnKeyPress}
              control={control}
              errors={errors.identityCode}
              rules={{
                required: true,
                minLength: 10,
                maxLength: 10,
                validate: IsNationalCode,
              }}
              minLength={10}
              maxLength={10}
            />
          </div>
        </form>
      </div>

      <div className="cta">
        <button className="btn btn-success btn-lg" onClick={handleSubmit(submitForm)}>
          {t('UPDATE_USER')}
        </button>
        <button className="btn btn-error btn-lg" onClick={() => navigate('/SignOut')}>
          {t('LOGOUT')}
        </button>
      </div>
    </BottomSheet>
  )
}

export default UserUpdate
